import { css, FlattenSimpleInterpolation } from "styled-components";
import { TooltipPlacement } from "./tooltip.types";

type placementRulesArgs = {
  [K in TooltipPlacement]: FlattenSimpleInterpolation;
};
type PlacementPartialProps = { placement: TooltipPlacement };

export const placementDependentStyles = ({
  top,
  right,
  bottom,
  left,
}: placementRulesArgs) => css<PlacementPartialProps>`
  ${(props) => props.placement === "top" && top}
  ${(props) => props.placement === "right" && right}
  ${(props) => props.placement === "bottom" && bottom}
  ${(props) => props.placement === "left" && left}
`;
